import classes from "../homePageNew.module.css";
import { StackIcon } from "./icons";

/**
 * Generic "nothing to show here" state for the detail pane — used whenever
 * there's no selected record (empty list, zero search results, etc.).
 * Takes just `moduleLabel` so any future module's detail pane can reuse the
 * exact same message/layout with its own name substituted in.
 *
 * `noDataAtAll` (default false) — this customer has literally zero runs
 * for this module (getHomePageData came back with an empty records array),
 * as opposed to the usual "nothing selected yet" moment (a fresh page load
 * before the first record auto-selects, or a search that matched nothing).
 * Those two are worded differently: the normal case invites picking a
 * record or adjusting the search, which is misleading advice when there's
 * nothing in the list to pick and no search box result to adjust.
 */
export default function EmptyRecordState({ moduleLabel, noDataAtAll = false }) {
  return (
    <div className={classes.emptyState}>
      <div className={classes.ic}>
        <StackIcon size={20} />
      </div>
      <div className={classes.t1}>No {moduleLabel} Data Available</div>
      <div className={classes.t2}>
        {noDataAtAll
          ? `Nothing has been run yet for ${moduleLabel} — once it has, it'll show up here.`
          : "There's nothing to show here yet. Select a record from the list, or adjust your search."}
      </div>
    </div>
  );
}
